import Header from "components/sections/headerV2/header"
import PropTypes from "prop-types"
import React, { useRef, useState } from "react"
import img3 from "../../../../static/images/calendar.svg"
import calendar from "../../../../static/images/CalendarX.svg"
import check from "../../../../static/images/Check.svg"
import img4 from "../../../../static/images/clock.svg"
import LogoGreen from "../../../../static/images/images/logo-green.svg"
import img5 from "../../../../static/images/location_on.svg"
import "./confirmAppointment.css"

function ConfirmAppointment({ appointmentDetails, prevStep, setFunction }) {
  const [errorMessage, setErrorMessage] = useState("")
  const [showw, setShoww] = useState(false)
  const [progressBarValue, setProgressBarValue] = useState(0)
  const bookAppointmentButton = useRef(null)

  const BookAppointment = async () => {
    const apiBodyContent = localStorage.getItem("bodyContent")
    setShoww(true)
    setProgressBarValue(0)
    loadingCounter()
    const apiBaseUrl =
      process.env.GATSBY_AXON_BASE_URL ||
      "https://pia1e7l5wi.execute-api.us-east-1.amazonaws.com/uat/welcomevisit"
    const bearerToken =
      process.env.GATSBY_AXON_BEARER_TOKEN ||
      "RjYzRTMyNjhERUE5MTg1NzozMkI0RDc0QzUzRkJFNjMyMkU3RTlDMzk3QThDNA=="
    let result_athena = await fetch(apiBaseUrl.concat("/booking"), {
      method: "PUT",
      mode: "cors",
      body: apiBodyContent,
      headers: {
        authorization: "Bearer ".concat(bearerToken),

        "Content-Type": "application/json",
      },
    })
    if (result_athena.status === 200) {
      result_athena = await result_athena.json()
      console.log("athena result", result_athena)
      setProgressBarValue(100)
      setFunction("Success")
    } else {
      setShoww(false)
      setProgressBarValue(0)
      setErrorMessage("BookingError")
    }
  }

  const loadingCounter = () => {
    const intervalId = setInterval(() => {
      setProgressBarValue(prev => {
        if (prev === 90) {
          clearInterval(intervalId)
          return 90
        } else {
          return prev + 10
        }
      })
    }, 2000)
  }

  return (
    <>
      <div>
        <Header />
      </div>
      <div className="confirm-appointment-container">
        <h2>Review Appointment Details</h2>
        <div className="error-text">
          {errorMessage === "LwcError" && (
            <h5>
              Oops! There was an error loading the credit card details. Please
              contact an Enrollment specialist at{" "}
              <a href="tel:888-885-5068">888-885-5068</a> to book your Welcome
              Visit.
            </h5>
          )}

          {errorMessage === "BookingError" && (
            <h5>
              Oops! There was an error booking your appointment. Please try
              another appointment.
            </h5>
          )}
        </div>
        <p>
          We look forward to finalizing your Welcome Visit appointment! Please
          see below for your selected appointment day and time and details on
          our cancellation policy and next steps!
        </p>
      </div>
      <div className="confirm-appointment-payment">
        <div className="col-left">
          <div className="appt-details-container">
            <div className="appointment-details">
              <h5>Welcome Visit</h5>
              <div>
                <div className="flex icons">
                  <img alt="calendar" src={img3} />
                  <p>{appointmentDetails.date}</p>
                </div>
                <div className="flex icons">
                  <img alt="clock" src={img4} />
                  <p>
                    {appointmentDetails.starttime}
                    {" - "}
                    {appointmentDetails.endtime}
                  </p>
                </div>
                <div className="flex icons">
                  <img alt="location" src={img5} />
                  <p>Telehealth</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-right-static">
          <div className="flex policies">
            <div className="cancel-policy">
              <div className="cancel-header">
                <img alt="calendar" src={calendar} /> Cancellation policy
              </div>
              <div className="cancel-text">
                <div>
                  <ul>
                    <li>
                      Please note that Cortica requires at least three days (72
                      hours) notice to cancel an appointment. This allows us to
                      offer your slot to other families in need of our services.
                    </li>
                    <li>
                      Appointment cancelations with less than 72 hours (three
                      days) notice will incur a $50 fee. No-shows will incur a
                      $100 fee. These fees are not billable to insurance. This
                      amount will be charged to the credit card number you
                      provide.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="nextstep-policy">
              <div className="nextstep-header">
                <img alt="checkmark" src={check} /> Next Steps
              </div>
              <div className="nextstep-text">
                <ol>
                  <li>
                    You will receive a confirmation email. Please review the
                    email and complete your intake forms
                  </li>
                  <li>
                    The information you provided will be verified with your
                    insurance and a detailed estimate of costs will be provided.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="confirm-appt-button-container">
        <button className="btn btnclose" onClick={prevStep} type="button">
          Go Back
        </button>
        <button
          className="btn btn-yellow float-right book-appointment"
          id="book-appointment"
          onClick={BookAppointment}
          ref={bookAppointmentButton}
          type="button"
        >
          Schedule Appointment
        </button>
      </div>
      {showw && (
        <div className="loader">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="img-wrapper">
                  <img alt="Logo" className="img-fluid" src={LogoGreen} />
                </div>
                <div className="content">
                  <h5 className="save-title">Please wait...</h5>
                  <p className="save-content">
                    We are scheduling your appointment!
                  </p>
                </div>
                <div className="ctm-progress">
                  <div className="progress-count">
                    <p>{progressBarValue} / 100 %</p>
                  </div>
                  <div className="progress">
                    <div
                      aria-valuemax="100"
                      aria-valuemin="0"
                      aria-valuenow="25"
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${progressBarValue}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
ConfirmAppointment.propTypes = {
  appointmentDetails: PropTypes.object.isRequired,
  prevStep: PropTypes.func.isRequired,
  setFunction: PropTypes.func.isRequired,
}

export default ConfirmAppointment
